export function savePZ(map: L.Map) {
	let pzState = JSON.parse(localStorage.getItem("pzState") || 'null');
	if (!pzState) {
		pzState = {
			zoom: 1,
			center: [0, 0]
		};
	}
	//p(pzState);
	map.setView(pzState.center, pzState.zoom);
	map.on('moveend', function () {
		pzState.zoom = map.getZoom();
		pzState.center = [map.getCenter().lat, map.getCenter().lng];
		localStorage.setItem("pzState", JSON.stringify(pzState));
	});
};
